
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { Chat } from '@/__env/lib/MercadoLibre/Chats';
    import { Scroll } from 'vuetify/es5/directives';
    import { Wait } from '@/__env/ext';
    import item from './lista-listado-item.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionado() { return this.Controlador.Seleccionado; }
        public set Seleccionado( x: Chat ) { this.Controlador.Seleccionado = x; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            document.getElementById( 'lista-chats' ).removeEventListener( 'scroll', this.onScroll );
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            document.getElementById( 'lista-chats' ).addEventListener( 'scroll', this.onScroll );
        }

        onScroll( ele: any )
        {
            let cc = ele.target.offsetHeight + ele.target.scrollTop - ele.target.scrollHeight;
            if ( cc > -50 && !this.BuscandoMas )
            {
                this.BuscarMas();
            }

        }

        public BuscandoMas: boolean = false;
        async BuscarMas()
        {
            if ( !this.Buscador.Paginacion )
                return;

            this.BuscandoMas = true;
            await Wait( 1000 );
            await this.Buscador.Buscar( this.Buscador.Paginacion.Pagina + 1, true );
            await Wait( 300 );
            this.BuscandoMas = false;
        }
    }
